
import { Vue, Component, Model, Prop } from "vue-property-decorator";
import { v4 as uuid } from "uuid";

@Component
export default class FormToggle extends Vue {
  @Prop({ type: String, default: undefined }) readonly label?: string;
  @Prop({ type: Boolean, default: false }) readonly labelHorizontal!: boolean;
  @Prop({ type: Boolean, default: false }) readonly labelLeft!: boolean;
  @Model("toggle", { type: Boolean }) readonly checked!: boolean;

  id: string = uuid();

  get labelClass(): Record<string, boolean> {
    return {
      "text-sm leading-5 text-gray-700": true,
      'ml-2': this.labelHorizontal && !this.labelLeft,
      'mr-2': this.labelHorizontal && this.labelLeft,
      'mt-1': !this.labelHorizontal,
    };
  }

  get primaryToggleClasses(): Record<string, boolean> {
    return {
      'translate-x-5': this.checked,
      'translate-x-0': !this.checked,
    };
  }

  get secondaryToggleClasses(): Record<string, boolean> {
    return {
      'bg-pink-300': this.checked,
      'bg-gray-300': !this.checked,
    };
  }

  toggle(): void {
    this.$emit("toggle", !this.checked);
  }
}
